export const FETCH_CONFIRM_USER = 'FETCH_CONFIRM_USER'
export const FETCH_CONFIRM_USER_SUCCESS = 'FETCH_CONFIRM_USER_SUCCESS'
export const FETCH_CONFIRM_USER_ERROR = 'FETCH_CONFIRM_USER_ERROR'
export const CLEAR_CONFIRM_USER = 'CLEAR_CONFIRM_USER'
